import Cookies from 'js-cookie'
import packageJson from '../package.json'

const apiUrlToWebSocketUrl = (apiUrl: string) => {
    const url = new URL(apiUrl)
    return `${url.protocol === 'http:' ? 'ws' : 'wss'}://${url.host}`
}

const localhost = false
const version = '2.9.1'
const proxy = null
const clientUrl = 'https://clientdevelopment.charge.sk'
const apiUrl = 'https://apidevelopment.charge.sk/api/'
const chargeTenantId = '8301fe71-bc7e-49ef-b97b-a16e2744aad9'
const appKey = 'd572601b-0651-47b8-b53c-832fce02a8e1'

export const config = localhost
    ? {
          api: '/api/',
          version: 'dev',
          websocket: 'wss://localhost:44374',
          proxy: packageJson.proxy,
          client: 'http://localhost:3000',
          chargeTenantId: '8301fe71-bc7e-49ef-b97b-a16e2744aad9',
          appKey: 'd572601b-0651-47b8-b53c-832fce02a8e1',
      }
    : {
          api: apiUrl,
          version: version,
          client: clientUrl,
          websocket: apiUrlToWebSocketUrl(apiUrl),
          proxy: proxy,
          chargeTenantId: chargeTenantId,
          appKey: appKey
      }

export const getToken = () => {
    return Cookies.get('clientToken')
}

export const setToken = (token: string) => {
    Cookies.set('clientToken', token)
}

export const removeToken = () => {
    Cookies.remove('clientToken')
}

export const getDefaultLanguage = () => {
    return Cookies.get('defaultLanguage')
}

export const setDefaultLanguage = (defaultLanguage: string) => {
    Cookies.set('defaultLanguage', defaultLanguage)
    return defaultLanguage
}

export const getTenant = () => {
    const urlObj = new URL(window.location.href)
    let host = urlObj?.hostname

    if (host.includes('www.')) {
        host = host.split('www.')[1]
    }

    host = host.split('.')[0]
    switch (host) {
        case 'siemens':
        case 'siemens-test':
        case 'siemens-healthineers':
            return 'siemens'
        case 'nedal-test':
            return 'nedal'
        default:
            return 'charge'
    }
}
